module Meevo.Plugins.DocsAndForms {

    declare const html_beautify: any;

    export interface IHtmlBeautyBuilder {
        fixDataAttribute(): void;
        replaceReservedWords(): void;
        clearAngularStuff(): void;
        fixEscapedStrings(): void;
        beautifyBR(): void;
        newTagFromNewLine(): void;
        removeReservedComments(): void;
        placeNewLinesForStartAndEnd(): void;
        addNewLinesBetweenBlocks(): void;
        removeEmptyLines(): void;
        attributesToTheNewLines(): void;
        moveCommentsToTheStart(): void;
        addSpacesInsideBlocks(): void;
        result(): string;
    }

    export class HtmlBeautyBuilder implements IHtmlBeautyBuilder {

        constructor(private html: string) {
        }

        public replaceReservedWords() {
            this.html = this
                .html
                .replace(`<!---stylesexample--->`, `<!---<link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/....">--->`)
                .replace(`<!---imgexmaple--->`, `<!---<img src="data:image/png;base64,...." alt=""/>--->`)
            ;
        }

        public clearAngularStuff() {
            this.html = this
                .html
                .replace(/class="ng-binding ng-scope"/g, '') // remove garbage
                .replace(/class="ng-binding"/g, '') // remove garbage
                .replace(/<!-- .*? -->/g, '') // remove angular comments
                .replace(/ng-[\w\-]+="(.)*?"/g, '') // remove ng-... attributes
                .replace(/meevo-switch-when=".*?"/g, '') // remove meevo-switch-when
                .replace(/class="ng-scope"/g, '') // remove class="ng-scope"
                .replace(/<span >((.|\n)*?)<\/span>/gm, `$1`) // replace `&quot;` symbol to the "
                ;
        }

        public fixEscapedStrings() {
            this.html = this
                .html
                .replace(/&lt;/g, '<') // change &lt; to <
                .replace(/&gt;/g, '>') // change &gt; to >
                .replace(/&quot;/gm, `"`) // replace `&quot;` symbol to the "
            ;
        }

        public newTagFromNewLine() {
            this.html = this
                .html
                .replace(/>( |\n)*?</g, '>\n<') // new tag from the new line
            ;
        }

        public removeReservedComments() {
            this.html = this
                .html
                .replace(/<!---removestart--->(.|\n)*?<!---removeend--->/g, '') // custom removable rows
            ;
        }

        public fixDataAttribute() {
            this.html = this
                .html
                .replace(/data-data="{(.*)?}"/gm, `data-data='{$1}'`) // replace data attribute to single qotes
            ;
        }

        public placeNewLinesForStartAndEnd() {
            this.html = this
                .html
                .replace(/<!-(Start) (.*)?->/g, '\n<!-$1 $2->') // add new line in the beginning andend of the comment
            ;
        }

        public removeEmptyLines() {
            this.html = this
                .html
                .replace(/^\s*\n/gm, '') // remove empty lines with empty value
            ;
        }

        public beautifyBR() {
            this.html = this
                .html
                .replace(/<br >\n<br >/gm, '<br/><br/>') // remove empty lines with empty value
            ;
        }

        public moveCommentsToTheStart() {
            this.html = this
                .html
                .replace(/^( )*<!/gm, '<!')
            ;
        }

        public attributesToTheNewLines() {
            const blockRe = /<!-Start (.*)?->(.|\n)*?<!-End \1->/g;
            const tagRe = /^( *)<(\w+) (.*?)>/gm;

            if (!blockRe.test(this.html)) return;

            // parse each control block in comment <!-Start ...->...<!-End ...->
            for (const controlBlock of this.html.match(blockRe)) {
                let tagResult: string[];

                while (tagResult = tagRe.exec(controlBlock)) {
                    const [oldLine, spaces, tagName, attributes] = tagResult;
                    const attrArray: string[] = attributes.match(/([\w-]+)="(.)*?"/gm);

                    // move attributes to the new line only if there are more then 1 attribute in the tag
                    if (attrArray.length < 2) continue;

                    // the space before each attribute, we use name of the tag + `<` sign + space before the first attribute
                    const tagNameSpaces: string = _.times(tagName.length + 2, _.constant(' ')).join('');
                    const newLine: string = `${spaces}<${tagName} ${attrArray.join(`\n${spaces + tagNameSpaces}`)}>`;

                    this.html = this
                        .html
                        .replace(oldLine, newLine)
                    ;
                }
            }
        }

        public addSpacesInsideBlocks() {
            const blockRe = /<!-Start (.*)?->(.|\n)*?<!-End \1->/g;

            if (!blockRe.test(this.html)) return;

            // parse each control block in comment <!-Start ...->...<!-End ...->
            for (const controlBlock of this.html.match(blockRe)) {
                const [parentTag] = controlBlock.match(/<(\w+)(.)*?>(.|\n)*<\/\1>/gm);

                this.html = this
                    .html
                    .replace(parentTag, html_beautify(parentTag))
                ;
            }
        }

        public addNewLinesBetweenBlocks() {
            this.html = this
                .html
                .replace('<!-System Tags->', '\n\n<!-System Tags->')
                .replace('<!-Custom Form Fields->', '\n\n<!-Custom Form Fields->')
                .replace('<!-User Defined Fields->', '\n\n<!-User Defined Fields->')
            ;
        }

        /**
         * Returns the completed result
         */
        public result(): string {
            return this.html;
        }

    }
}

